export const LANG_VERSIONS = {    
    "python": "3.10.0",
    "java":"15.0.2",
    
    
    
  };

//   export const CODE_TEMPLATES = {
//     javascript: `function greet(name) {
//         console.log("Hello, " + name + "!");
//     }    
// greet("Paul");`,
//     typescript: `type Params = {
//         name: string;
//     };
    
// function greet(data: Params) {
//     console.log("Hello, " + data.name + "!");
// }
    
// greet({ name: "Paul" });
//         `,
//     python: `class Solution(object):
//         def twoSum(self, nums, target):`,

//     java: `class Solution {
//         public int[] twoSum(int[] nums, int target) {
        
//         }   
// }`
//   };